export const USER_DATA = 'slashtemplate_user_data';